import classNames from 'classnames';
import React from 'react';

import { Layout as BaseLayout } from '@sravni/react-design-system';

import styles from './styles.module.scss';

export const Layout: React.FC<React.ComponentProps<typeof BaseLayout>> = (props) => {
  return <BaseLayout {...props} className={classNames(styles.layout, props.className)} />;
};
